export default {
  template: `
  <template label="${edicom.locale.translate('enrollment.bmpwelcome.title')}">
    <ewc-title level="3" label="${edicom.locale.translate('enrollment.bmpwelcome.bm.title')}"></ewc-title>
    <ewc-alert type="flat">
      <div style="white-space:normal;">
        ${edicom.locale.translate('enrollment.bmpwelcome.bm.firstParagraph')}<br/><br/>
        ${edicom.locale.translate('enrollment.bmpwelcome.bm.secondParagraph.1')}<br/>
        ${edicom.locale.translate('enrollment.bmpwelcome.bm.secondParagraph.2')}<br/>
        ${edicom.locale.translate('enrollment.bmpwelcome.bm.secondParagraph.3')}<br/><br/>
        ${edicom.locale.translate('enrollment.bmpwelcome.bm.secondParagraph.4')}
      </div>
    </ewc-alert>
  </template>`,
};
